/**
 *  画面項目フォーム.
 */
export class BaseForm {
  /** 項目値. */
  value: string | number | boolean ;

  /** 項目名. */
  key: string;

  /** 表示名. */
  label: string;

  /** 必須. */
  required: boolean;

  /** フォーム順序. */
  order: number;

  /** コントロールタイプ. */
  controlType: string;

  /** input type. */
  type: string;

  /** 選択値. */
  options: { key: string, value: string | number | boolean }[];

  /** 最大桁数. */
  maxLength: number;

  /** バリデーションパターン. */
  validatorPattern: {
    pattern: string | RegExp,
    message: string
  };

  /** 非活性制御. */
  disable: boolean;

  /** 項目分類. */
  field: string;

  constructor(options: {
      value?: string | number | boolean;
      key?: string;
      label?: string;
      required?: boolean;
      order?: number;
      controlType?: string;
      type?: string;
      options?: {key: string, value: string}[];
      maxLength?: number;
      validatorPattern?: {
        pattern: string | RegExp,
        message: string
      };
      disable?: boolean;
      field?: string;
    } = {}) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.type = options.type || '';
    this.options = options.options || [];
    this.maxLength = options.maxLength || null;
    this.validatorPattern = options.validatorPattern || null;
    this.disable = !!options.disable;
    this.field = options.field || '';
  }
}



// WEBPACK FOOTER //
// ./src/providers/input-form/models/base-form.ts